import moment from "moment";
import { DAY_OF_WEEKS, DAY_OF_WEEKS_NUMBER } from "../constants/DAY";
import { find, isDate, isNumber, startsWith } from "lodash";
import { isTestCompany } from "./auth";

export const viewFormat = "YYYY.MM.DD";
export const format = "YYYY-MM-DD";
export const formatHour = `HH:mm`;
export const formatDateHour = `${format} ${formatHour}`;
export const formatHourSecond = `HH:mm:ss`;
export const apiFomat = "YYYY-MM-DD";
export const formatFullDateTime = `${format} ${formatHourSecond}`;

// 해석이 안될경우를 대비해서 실행
// export const formatTypes = [viewFormat, format, formatHour, formatDateHour, formatHourSecond,]

export const now = () => {
  return isTestCompany() ? moment(process.env.REACT_APP_TEST_DATE) : moment(new Date());
};

//  t1 - t2  초
export const getSecondsDiff = (t1, t2 = now()) => {
  return moment.duration(moment(t1).diff(moment(t2))).asSeconds();
};

export const isSameDay = (t1, t2 = now()) => {
  return moment(t1).format(format) === moment(t2).format(format);
};

export const dateToFormat = (date = now(), formatString = format) => {
  let result = moment(date).format(formatString);
  if (result === "Invalid date") {
    result = moment(date, formatString).format(formatString);
  }
  return result !== "Invalid date" ? result : "";
};

export const dateToViewFormat = (date = now(), formatString = viewFormat) => {
  let result = moment(date).format(formatString);
  if (result === "Invalid date") {
    result = moment(date, formatString).format(formatString);
  }
  return result !== "Invalid date" ? result : "";
};

export const dateToHourSecondFormat = (date = now(), formatString = formatHourSecond) => dateToFormat(date, formatString);

export const dateToViewFormatWithDayName = (
  date = now(),
  formatString = viewFormat
) => {
  return dateToViewFormat(date, formatString) !== "" ? `${dateToViewFormat(date, formatString)} (${getDayName(date)})` : "";
};
export const dateToViewFormatWithDayNameWithTime = (
  date = now(),
  formatString = viewFormat
) => {
  return dateToViewFormat(date, formatString) !== "" ?
    `${dateToViewFormat(date, formatString)} (${getDayName(
      date
    )}) ${getFormatHour(date)}` : "";
};

export function getFormatDateHour(date = now()) {
  return dateToFormat(date, formatDateHour);
}

export function getFormatHour(date) {
  return dateToFormat(date, formatHour);
}

export const getDayName = (date) => {
  const dayOfWeek = find(
    DAY_OF_WEEKS,
    ({ name }) => name === moment(date).format("ddd").toLowerCase()
  );
  return dayOfWeek ? dayOfWeek.label : "";
};

export const getDay = (days = 0, formatString) => {
  return dateToFormat(now().subtract(days, "days"), formatString);
};

export const getFutureDay = (days = 0, formatString, date = now()) => {
  const _d = isDate(date) ? date : moment(date);
  return dateToFormat(_d.add(days, "days"), formatString);
};

export const getMonth = (date = now(), months = 0, formatString) => {
  const _d = isDate(date) ? date : moment(date);
  return dateToFormat(_d.subtract(months, "months"), formatString);
};

export const getFutureMonth = (date = now(), months = 0, formatString) => {
  const _d = isDate(date) ? date : moment(date);
  return dateToFormat(_d.add(months, "months"), formatString);
};

export const getYear = (years = 0) => {
  return dateToFormat(now().subtract(years, "years"));
};

export const getWeekRange = (weekMargin = 0, weekType = "isoWeek") => {
  const week = now().subtract(weekMargin, "week");
  return {
    from: dateToFormat(week.startOf(weekType)),
    to:
      weekMargin === 0
        ? dateToFormat(now())
        : dateToFormat(week.endOf(weekType)),
  };
};

export const getWeekNumberOfMonth = (date) => {
  const target = moment(date)._d;
  var selectedDayOfMonth = target.getDate();
  var first = new Date(
    target.getFullYear() + "/" + (target.getMonth() + 1) + "/01"
  );
  var monthFirstDateDay = first.getDay();
  return Math.ceil((selectedDayOfMonth + monthFirstDateDay) / 7);
};

export const getMonthRange = (monthMargin = 0, isFullMonthDate, date = new Date()) => {
  const month = moment(date).subtract(monthMargin, "month");
  return {
    from: dateToFormat(month.startOf("month")),
    to:
      monthMargin === 0 && !isFullMonthDate
        ? dateToFormat(now())
        : dateToFormat(month.endOf("month")),
  };
};

export const secondsToHourSecond = (seconds) => {
  return moment.utc(seconds * 1000).format(formatHourSecond);
};

export const hourSecondToseconds = (time) => {
  return moment.duration(time).asSeconds();
};

// startDate 와 endDate의 날짜 차이 계산
export const diffDays = (startDate, endDate = now()) => {
  const start = moment(startDate);
  const end = moment(endDate);
  const duration = moment.duration(end.diff(start));
  const diffDays = duration.asDays();
  return diffDays;
};

export const diffSeconds = (startDate, endDate = now()) => {
  const start = moment(startDate);
  const end = moment(endDate);
  const duration = moment.duration(end.diff(start));
  const diffSeconds = duration.asSeconds();
  return diffSeconds;
};

export const convertWorkTime = (time) => {
  time = Number(time);
  if (!time || isNaN(time)) return "없음";
  if (time < 0) {
    return "00:00";
  }
  const hour = Math.floor(Number(time));
  const minutes = Math.ceil((Number(time) - hour) * 60);
  return `${hour}:${minutes}`;
};

export const getHour = (date) => {
  if (!date) return "-";
  return dateToFormat(date, formatHour);
};

// 시작일과 종료일 입력시 date list 를 반환
export const getDateRangeList = (startDate, endDate) => {
  const dateList = [];
  let start = dateToFormat(startDate);
  const end = dateToFormat(endDate || startDate);
  while (start <= end) {
    dateList.push(start);
    start = dateToFormat(moment(start).subtract(-1, "days"));
  }
  return dateList;
};
export const getYearMonthDay = (date) => {
  return {
    year: dateToFormat(date, "YYYY"),
    month: dateToFormat(date, "MM"),
    day: dateToFormat(date, "DD"),
    dayName: getDayName(date),
  };
};

// 전일 계산
export const yesterDay = (date) => {
  return dateToFormat(moment(date).subtract(1, "day"));
};

/*
export const dateOptionList = [
  {
    label: "오늘",
    datas: {
      from: getDay(),
      to: getDay(),
    },
  },
  {
    label: "최근 1주일",
    datas: {
      from: getDay(7),
      to: getDay(),
    },
  },
  {
    label: "이번 주",
    datas: {
      ...getWeekRange(),
    },
  },
  {
    label: "이번 달",
    datas: {
      ...getMonthRange(),
    },
  },
  {
    label: "지난 달",
    datas: {
      ...getMonthRange(1),
    },
  },
];
*/

const getQuarterRange = (year, month, isCurrent) => {
  const range = [];

  let quarter = 4;
  if (isCurrent) {
    quarter = Math.ceil(month / 3);
  }

  let firstDate, lastDate;
  for (let i = 1; i <= quarter; i++) {

    firstDate = year + "-" + (i + (i - 1) * 2) + "-01";
    if (i === 2 || i === 3) { // 6,9월 30일까지
      lastDate = year + "-" + (i * 3) + "-30";
    } else {
      lastDate = year + "-" + (i * 3) + "-31";
    }

    if (isCurrent && i === quarter) {
      lastDate = getDay();
    }

    range.push({ label: i + "분기", colSpan: 1, from: firstDate, to: lastDate });
  }

  return range;
};

const getMonthYearRange = (month, isCurrent) => {
  const range = [[]];
  let subRanage = [];

  let count = month;
  let iRange = month;

  if (!isCurrent) {
    count = 12;
    iRange = month + 12;
  }

  for (let i = 1; i <= count; i++) {
    const rangeDay = getMonthRange(iRange - i, false);
    subRanage.push({ label: i + "월", colSpan: 1, from: rangeDay.from, to: rangeDay.to });

    if (i === 4 || i === 8 || i === count) {
      range.push(subRanage);
      subRanage = [];
    }
  }

  return range;
};

export const dateOptionListEx = () => {
  const currentYear = getCurrentYear();
  const preYear = currentYear - 1;

  const currentMonth = new Date().getMonth() + 1;

  const range = [
    [
      {
        label: "지난주",
        colSpan: 1,
        ...getWeekRange(1),
      },
      {
        label: "이번주",
        colSpan: 1,
        ...getWeekRange(),
      },
      {
        label: "지난달",
        colSpan: 1,
        ...getMonthRange(1),
      },
      {
        label: "이번달",
        colSpan: 1,
        ...getMonthRange(),
      },
    ]
  ];

  range.push([{
    label: "당해연도",
    colSpan: 4,
    from: currentYear + "-01-01",
    to: getDay(),
  },]);

  range.push(getQuarterRange(currentYear, currentMonth, true)); // 당해연도 / 분기
  const monthRange = getMonthYearRange(currentMonth, true); // 당해연도 / 월
  monthRange.forEach((item) => {
    range.push(item);
  });

  range.push([{
    label: "전년도",
    colSpan: 4,
    from: preYear + "-01-01",
    to: preYear + "-12-31",
  },]);

  range.push(getQuarterRange(preYear, currentMonth, false)); // 전년도 / 분기
  getMonthYearRange(currentMonth, false).forEach((item) => { // 전년도 / 월
    range.push(item);
  });

  return range;
};


export const getYearRange = (
  startYear = new Date().getFullYear(),
  term = 10
) => {
  const currentYear = startYear;
  const minYear = currentYear - term + 1;
  const years = [];
  let i = currentYear;
  for (i; i >= minYear; i--) {
    years.push({ label: `${i}년`, value: i });
  }

  return years;
};

export const getCurrentYear = (
  currentYear = new Date().getFullYear()
) => {

  return currentYear;
};

export const getYearAddOneRange = (
  startYear = new Date().getFullYear(),
  term = 10
) => {
  const currentYear = startYear;
  const minYear = currentYear - term + 1;
  const years = [];
  let i = currentYear + 1;
  for (i; i >= minYear; i--) {
    years.push({ label: `${i}년`, value: i, selected: true });
  }

  return years;
};

export const monthDayFormat = (value) => {
  let date = value.toString();
  if (value.length === 1) date = "0" + value;
  if (value.length === 2 && startsWith(value, "0")) date = value.replace("0", "");
  return date;
};

export const dateDayofWeekFormat = (date, formatString = viewFormat) => {
  let result = moment(date);
  const dowValue = result.isoWeekday();
  const dow = DAY_OF_WEEKS_NUMBER.find((item) => item["value"] === dowValue);

  return `${result.format(formatString)} (${dow["label"]})`;
};

export const getWeekOfMonth = (date) => {
  const target = moment(date)._d;
  const selectedDayOfMonth = target.getDate();
  const first = new Date(
    target.getFullYear() + "/" + (target.getMonth() + 1) + "/01"
  );
  const monthFirstDateDay = first.getDay();
  return Math.ceil((selectedDayOfMonth + monthFirstDateDay) / 7);
};

export const getWeeksInMonth = (year, month) => {
  const weeks = [],
    firstDate = new Date(year, month - 1, 1),
    lastDate = new Date(year, month, 0),
    numDays = lastDate.getDate();

  let dayOfWeekCounter = firstDate.getDay();

  for (let date = 1; date <= numDays; date++) {
    if (dayOfWeekCounter === 0 || weeks.length === 0) {
      weeks.push([]);
    }
    weeks[weeks.length - 1].push(date);
    dayOfWeekCounter = (dayOfWeekCounter + 1) % 7;
  }

  return weeks
    .filter((w) => !!w.length)
    .map((w) => ({
      start: w[0],
      end: w[w.length - 1],
      dates: w,
    }));
};

export const secondsToTime = (seconds) => {
  if (!isNumber(seconds)) return {
    hours: 0,
    minutes: 0,
    seconds: 0,
    secondsOrigin: seconds,
  };
  seconds = Number(seconds);
  return {
    hours: parseInt(seconds / 3600),
    minutes: parseInt((seconds % 3600) / 60),
    seconds: parseInt(seconds % 60),
    secondsOrigin: seconds
  };
};

// 중간에 포함되어있는지 구하기
export const hasInRange = (start, end, current = now()) => {
  const _start = start && getFormatDateHour(start);
  const _end = end && getFormatDateHour(end);
  const _current = getFormatDateHour(current);
  return (!_start || _start <= _current) && (!_end || _end >= _current);
};

export const getWeekRangeDateTime = () => {
  const week = now().subtract(0, "week");
  return {
    from: dateToFormat(week.startOf("isoWeek"), formatDateHour),
    to: dateToFormat(week.endOf("isoWeek"), formatDateHour),
  };
};

export const getWeekOfDate = (date = now()) => {
  return moment(date).day();
};